import {
  useSelectTheme,
  useSelectMethod,
  useSelectTempTaskData,
  useSelectProjectData,
} from "../../store";
import { useCreateTaskColorTranslator, RIF, sortBy } from "../../lib";
import { useParams } from "react-router-dom";
import { Tooltip } from "..";
import MobileAppPreviewImg from "../../asset/image/mobile_app_preview.png";
import {
  RepeatIcon,
  AboutProjectIcon,
  ParticipantTaskIcon,
  InstructionIcon,
  ContactsIcon,
} from "../../asset/image";
import MainPageMockPreviewImg from "../../asset/image/main_page_mock_preview.png";
import { TaskStateType, TempTask, getTaskContentName, ProjectContent } from "../../model";
import { TaskType } from "../../shared/db";

export interface MobileAppPreviewPropsT {
  projectContent: ProjectContent | null;
  currentBlock: string;
}

export const MobileAppPreview = (props: MobileAppPreviewPropsT) => {
  const { pad, color, fontWeight, fontSize } = useSelectTheme();

  const { projectContent, currentBlock } = props;

  const methodState = useSelectMethod();
  const taskList: TaskStateType[] =
    methodState?.taskList
      ?.filter((item: TaskStateType) => item.type !== TaskType.GarminDevice && item.enabled)
      .sort(sortBy("index")) || [];
  const tempTaskData = useSelectTempTaskData();
  const tempTaskList =
    tempTaskData?.taskList?.filter(
      (item: TempTask) => item.type !== TaskType.GarminDevice && item.enabled,
    ) || [];
  const { projectId } = useParams();
  const project = useSelectProjectData()[projectId];
  const isEditingLiveProject = project?.status === "live";

  return (
    // background
    <div
      css={{
        width: "280px",
        height: "500px",
        padding: "30px 40px",
        backgroundImage: `url(${MobileAppPreviewImg})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "fixed",
        top: isEditingLiveProject ? "100px" : "60px",
        right: "30px",
      }}
    >
      {/* container */}
      <div css={{ width: "100%", height: "98%", overflowY: "hidden" }}>
        {/* aboutProject */}
        {RIF(
          currentBlock === "aboutProject" || currentBlock === "device",
          <div css={{ width: "100%", padding: `45px 15px` }}>
            <div
              css={{
                width: "40px",
                height: "40px",
                background: color.background,
                borderRadius: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "16px",
              }}
            >
              <img src={AboutProjectIcon} width="24px" alt="" aria-hidden />
            </div>
            <p
              css={{
                fontSize: fontSize.h5,
                fontWeight: fontWeight.thick,
                marginBottom: "16px",
              }}
            >
              About Project
            </p>
            <p css={{ fontSize: fontSize.h7, fontWeight: fontWeight.bold, marginBottom: pad.xs }}>
              Project
            </p>
            <p
              css={{
                fontSize: fontSize.h7,
                color: color.textIcon.secondary,
                marginBottom: "15px",
                wordBreak: "break-word",
                whiteSpace: "break-spaces",
              }}
            >
              {projectContent?.name || "Labfront Sleep Study"}
            </p>

            <p css={{ fontSize: fontSize.h7, fontWeight: fontWeight.bold, marginBottom: "5px" }}>
              Principal Investigator
            </p>
            <p
              css={{
                fontSize: fontSize.h7,
                color: color.textIcon.secondary,
                marginBottom: "15px",
                wordBreak: "break-word",
                whiteSpace: "break-spaces",
              }}
            >
              {projectContent?.investigator || "Dr. Luna Shiba"}
            </p>

            <p css={{ fontSize: fontSize.h7, fontWeight: fontWeight.bold, marginBottom: "5px" }}>
              Organization or Institution
            </p>
            <p
              css={{
                fontSize: fontSize.h7,
                color: color.textIcon.secondary,
                marginBottom: "15px",
                wordBreak: "break-word",
                whiteSpace: "break-spaces",
              }}
            >
              {projectContent?.organization || "Labfront"}
            </p>

            <p css={{ fontSize: fontSize.h7, fontWeight: fontWeight.bold, marginBottom: "5px" }}>
              Introduction
            </p>
            <p
              css={{
                color: color.textIcon.secondary,
                overflowWrap: "break-word",
                whiteSpace: "pre-line",
                fontSize: fontSize.h7,
              }}
            >
              {projectContent?.description || `Briefly introduce your study here.`}
            </p>
          </div>,
        )}

        {/* participant task */}
        {RIF(
          currentBlock === "participantTask",
          <div css={{ width: "100%", height: "100%", overflowY: "hidden" }}>
            <img
              src={MainPageMockPreviewImg}
              alt="Preview of the participant mobile app home screen"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
              css={{ borderRadius: "20px", zIndex: 1 }}
            />
          </div>,
        )}

        {/* Instructions & Contact */}
        {RIF(
          currentBlock === "instruction" || currentBlock === "contacts",
          <div css={{ width: "100%", padding: `45px 15px` }}>
            <div
              css={{
                width: "40px",
                height: "40px",
                background: color.background,
                borderRadius: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "16px",
              }}
            >
              <img
                src={currentBlock === "instruction" ? InstructionIcon : ContactsIcon}
                width="24px"
                alt=""
                aria-hidden
              />
            </div>
            <p
              css={{
                fontSize: fontSize.h5,
                fontWeight: fontWeight.thick,
                marginBottom: "16px",
              }}
            >
              {currentBlock === "instruction" ? "Instructions" : "Contact Organizer"}
            </p>
            {RIF(
              currentBlock === "instruction",
              <p
                css={{
                  fontSize: fontSize.h7,
                  fontWeight: fontWeight.bold,
                  whiteSpace: "break-spaces",
                }}
              >
                {projectContent?.instructionValue ||
                  "Please read through documents provided to you carefully."}
              </p>,
            )}
            {RIF(
              currentBlock === "contacts",
              <p
                css={{
                  fontSize: fontSize.h7,
                  fontWeight: fontWeight.bold,
                  whiteSpace: "break-spaces",
                }}
              >
                {projectContent?.contactValue ||
                  "If you have any questions or encounter issues during the project, please contact alix@bestuniversity.edu"}
              </p>,
            )}
          </div>,
        )}
      </div>

      <div
        css={{
          width: "105px",
          position: "absolute",
          bottom: "-20px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        App Preview
        <Tooltip content="This is what participants will see on their app." />
      </div>
    </div>
  );
};

interface AppTaskTagProps {
  index: number;
  task?: TaskStateType | TempTask;
}

const AppTaskTag = (props: AppTaskTagProps) => {
  const { color, fontWeight } = useSelectTheme();
  const colorTranslator = useCreateTaskColorTranslator();
  const { task, index } = props;

  return (
    <>
      {RIF(task, (task) => {
        const taskContentName = getTaskContentName(task.type);
        const content = task[taskContentName];
        return (
          <div
            css={{
              width: "100%",
              minHeight: "56px",
              border: `1px solid ${color.grey_100}`,
              borderLeft: task.color
                ? `4px solid #${task.color}`
                : `4px solid ${colorTranslator(index)}`,
              borderRadius: "3px",
              boxShadow: "#D4D4D440",
              padding: "10px 15px",
              marginBottom: "8px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: "5px",
            }}
          >
            {RIF(content?.name, (name) => (
              <div
                css={{
                  fontSize: "12px",
                  fontWeight: fontWeight.thick,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {name}
              </div>
            ))}
            {RIF(
              task.scheduleRepeat || task.scheduleDescription,
              <div
                css={{
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                {RIF(
                  task.scheduleRepeat,
                  <img src={RepeatIcon} width="14" height="14" alt="" aria-hidden />,
                )}
                {RIF(task.scheduleDescription, (description) => (
                  <p
                    css={{
                      fontSize: "12px",
                      color: color.grey_400,
                      WebkitTransform: "scale(0.9)",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {description}
                  </p>
                ))}
              </div>,
            )}
          </div>
        );
      })}
    </>
  );
};
